import { ErrorReportingClient } from '../types/ErrorReportingClient';
import { ErrorReportingDevtools } from '../types/ErrorReportingDevtools';

/**
 * Adds an arbitrary breadcrumb to the current Sentry scope under the
 * `devtools` category so QA can annotate test steps inline with the
 * breadcrumb timeline.
 */
export const createBreadcrumbDevtool = (
  client: ErrorReportingClient,
): ErrorReportingDevtools['breadcrumb'] => {
  return (message, data): void => {
    client.addBreadcrumb({
      category: 'devtools',
      data,
      level: 'info',
      message,
      timestamp: Date.now() / 1000,
    });
  };
};
